import React from 'react'
import { Helper } from '../../../../../classes/helper'
import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { Tube } from '@react-three/drei'
import { Keys } from '../../../../../hooks/state/utlility/utils'
import { LineCurve3, Vector3 } from 'three'

interface Props {
  position: number[]
}

export const RoundHandle = ({ position }: Props): JSX.Element => {
  const { sidwallTyp, type } = useSidewall()
  const pos: [number, number, number] = [
    position[0] +
      (type === Keys.Seitenwände.Values.SeitenwandRechts.key
        ? 0
        : sidwallTyp.glas),
    position[1],
    position[2],
  ]

  const path = new LineCurve3(
    new Vector3(0, 0, 0),
    new Vector3(0, sidwallTyp.glas, 0)
  )

  return (
    <>
      <mesh
        castShadow={true}
        position={pos}
        rotation={[
          Helper.convertAngleToRadiant(0),
          Helper.convertAngleToRadiant(0),
          Helper.convertAngleToRadiant(90),
        ]}
      >
        <Tube args={[path, 20, 0.02, 8, true]}>
          <CachedMeshPhysicalMaterial color="silver" />
        </Tube>
      </mesh>
    </>
  )
}
